import React from 'react';
import PropTypes from 'prop-types';
import {
  Avatar,
  Icon,
  List,
} from 'antd';

import DropdownMenu from '../shared/DropdownMenu';
import defaultUserAvatarImage from '../../styles/images/no_testimonial_avatar_image.png';

import '../../styles/css/MemberListItem.css';

const MemberListItem = ({
  actions,
  loading,
  showMenu,
  user,
}) => (
  <List.Item
    className="member-list-item"
    key={user.id}
    extra={
      showMenu && (
        <DropdownMenu
          dataSource={actions}
          disabled={loading}
        >
          <Icon
            className="member-list-item-actions-icon"
            type={loading ? 'loading' : 'more'}
          />
        </DropdownMenu>
      )
    }
  >
    <List.Item.Meta
      className="member-list-item-meta"
      avatar={
        <Avatar
          size={40}
          src={defaultUserAvatarImage}
          srcSet={user.avatar}
        />
      }
      title={`${user.firstName} ${user.lastName}`}
    />
  </List.Item>
);

MemberListItem.propTypes = {
  actions: PropTypes.arrayOf(PropTypes.object),
  loading: PropTypes.bool,
  showMenu: PropTypes.bool,
  user: PropTypes.shape({
    id: PropTypes.number,
    avatar: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
  }),
};

MemberListItem.defaultProps = {
  actions: [],
  loading: false,
  showMenu: true,
  user: {},
};

export default MemberListItem;



// WEBPACK FOOTER //
// ./src/components/messaging/MemberListItem.js